if (!customElements.get('video-loader')) {
    customElements.define('video-loader', class videoLoader extends HTMLElement {

      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mql.addEventListener("change", this.checkScreenChange.bind(this), { once: true });
        this.checkScreenChange();
      }

      loadOnlyVisibleVideo(device) {
        var videos = document.querySelectorAll(`[data-${device}-video]`);
        videos.forEach((videoWrapper => {
            var video = videoWrapper.querySelector('video');
            if (video) {
            const visible = video.offsetWidth ||
                video.offsetHeight ||
                video.getClientRects().length;

            if (visible) {
                const children = video.getElementsByTagName("source");
                for (let i = 0; i < children.length; ++i) {
                children[i].src = children[i].dataset.src;
                }
            }
            video.load();
            }
        }));
      }

      checkScreenChange() {
        if (this.mql.matches){
          this.loadOnlyVisibleVideo('desktop')
        } else {
          this.loadOnlyVisibleVideo('mobile')
        }
      }
    })
  }